import request from '@/utils/request'

let XiaotestApi = {

  /*小测试列表*/
  list(data) {
    return request._post('/shop/plus.xiaotest.Index/index', data);
},
/*添加小测试*/
add(data) {
    return request._post('/shop/plus.xiaotest.Index/add', data);
},
/*修改小测试*/
edit(data) {
    return request._post('/shop/plus.xiaotest.Index/edit', data);
},
/*删除小测试*/
del(data) {
    return request._post('/shop/plus.xiaotest.Index/del', data);
},
/*小测试详情*/
detail(data) {
  return request._post('/shop/plus.xiaotest.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.xiaotest.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.xiaotest.Setting/getSetting', data, errorback);
    },
}
export default XiaotestApi;



// WEBPACK FOOTER //
// ./src/api/xiaotest.js